// App.jsx
import './App.css';
import {
  createBrowserRouter,
  RouterProvider,
} from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import AuthLayout from './layout/auth-layout/AuthLayout';
import LoginComponent from './components/auth/login/LoginComponent';
import RegisterComponent from './components/auth/register/RegisterComponent';
import VerifyCode from './components/auth/verify-code/VerifyCode';
import ForgetPassword from './components/auth/forget-password/ForgetPassword';
import AuthCallback from './components/auth/google-auth-callback/GoogleAuthCallback';
import Home from './pages/home/Home';
import ProductsCollectionList from './pages/products_collection_list/ProductsCollectionList';
import MainLayout from './layout/main-layout/MainLayout';
import ProductProfile from './pages/product_profile/ProductProfile';
import ScrollToTop from './components/general/ScrollToTop';
import PageLoader from './components/general/PageLoader/PageLoader';
import AboutUs from './pages/about_us/AboutUs';
import PrivacyPolicy from './pages/privacy_policy/PrivacyPolicy';
import UserProfile from './components/user_profile/UserProfile';
import { useEffect } from 'react';
import CheckoutPage from './pages/checkout_page/CheckoutPage';
import ProtectedRoute from './components/general/protected_route/ProtectedRoute';
import Wishlist from './components/general/wishlist/Wishlist';
import ContactUs from './pages/contact_us/ContactUs';
import { trackPageView } from './analytics/analytics';

const router = createBrowserRouter([
  {
    path: '/auth/callback',
    element: (
      <>
        <ScrollToTop />
        <PageLoader /> 
        <AuthCallback />
      </>
    ),
  },
  {
    path: '/',
    element: (
      <>
        <ScrollToTop />
        <PageLoader /> 
        <MainLayout/>
      </>
    ),
    children: [
      {
        index: true,
        path: '/',
        element: <Home />,
      },
    ]
  },
  {
    path: '/auth',
    element: (
      <>
        <ScrollToTop />
        <AuthLayout />
      </>
    ),
    children: [
      {
        index: true,
        element: <LoginComponent />,
      },
      {
        path: 'login',
        element: <LoginComponent />,
      },
      {
        path: 'register',
        element: <RegisterComponent />,
      },
      {
        path: 'forget-password',
        element: <ForgetPassword />,
      },
      {
        path: 'verify',
        element: <VerifyCode />,
      },
    ],
  },
  {
    path: '/collection',
    element: (
      <>
        <ScrollToTop />
        <PageLoader /> 
        <MainLayout />
      </>
    ),
    children: [
      {
        path: ':collectionName',
        element: <ProductsCollectionList />,
      },
      {
        path: ':collectionName/:categoryName',
        element: <ProductsCollectionList />,
      },
      {
        path: ':collectionName/:categoryName/:productId',
        element: <ProductProfile />,
      },
      {
        path: ':collectionName/:categoryName/:subCategoryName/:productId',
        element: <ProductProfile />,
      },
    ],
  },
  {
    path: '/about-us',
    element: (
      <>
        <ScrollToTop />
        <PageLoader />
        <MainLayout />
      </>
    ),
    children: [
      {
        index: true,
        element: <AboutUs />,
      },
    ],
  },
  {
    path: '/privacy-policy',
    element: (
      <>
        <ScrollToTop />
        <PageLoader />
        <MainLayout />
      </>
    ),
    children: [
      {
        index: true,
        element: <PrivacyPolicy />,
      },
    ],
  },
  {
    path: '/contact-us',
    element: (
      <>
        <ScrollToTop />
        <PageLoader />
        <MainLayout />
      </>
    ),
    children: [
      {
        index: true,
        element: <ContactUs />,
      },
    ],
  },
  {
    path: '/profile',
    element: (
      <>
        <ScrollToTop />
        <PageLoader />
        <MainLayout />
      </>
    ),
    children: [
      {
        index: true,
        element: (
          <ProtectedRoute>
            <UserProfile />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: '/checkout',
    element: (
      <>
        <ScrollToTop />
        <PageLoader />
        <MainLayout />
      </>
    ),
    children: [
      {
        index: true,
        element: (
          // <ProtectedRoute>
            <CheckoutPage />
          // </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: '/wishlist',
    element: (
      <>
        <ScrollToTop />
        <PageLoader />
        <MainLayout />
      </>
    ),
    children: [
      {
        index: true,
        element: (
          // <ProtectedRoute>
            <Wishlist />
          // </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: '*',
    element: (
      <>
        <ScrollToTop />
        <PageLoader /> 
        <div>page not found</div>
      </>
    ),
  },
]);

function App() {

  useEffect(() => {
    document.title = "Addmix - Your Ultimate Fashion Destination";
    const link = document.querySelector("link[rel~='icon']");
    if (link) {
      link.href = '/assets/login-form-logo3.png';
    }
  }, []);

  useEffect(() => {
    let previousLocation = null;

    const track = (location) => {
      const currentPath =
        location.pathname + location.search + location.hash;

      if (currentPath === previousLocation) {
        return;
      }

      previousLocation = currentPath;

      trackPageView(location);
    };

    // Initial page view
    track(router.state.location);

    // React Router navigation
    const unsubscribe = router.subscribe((state) => {
      if (state.navigation.state === 'idle') {
        track(state.location);
      }
    });

    return unsubscribe;
  }, []);

  return (
    <div className="App">
      <RouterProvider router={router} />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default App;